import React, { useState } from 'react';
import { Plus, UploadCloud, FolderPlus, X, FileUp, ArrowLeft, Home } from 'lucide-react';
import { Button } from "./ui/button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "./ui/tooltip";
import { cn } from "../lib/utils";

const FloatingActionMenu = ({
    onUploadFile,
    onCreateFolder,
    onUploadFolder,
    currentFolder,
    onBack,
    onHome
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => setIsOpen(!isOpen);

    return (
        <div className="fixed bottom-8 right-8 z-50 flex flex-col items-end gap-3">
            {/* Menu Options */}
            <div className={cn(
                "flex flex-col gap-3 transition-all duration-300 ease-in-out",
                isOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 translate-y-10 invisible h-0"
            )}>

                {/* Navigation Options (Only if currentFolder exists) */}
                {currentFolder && (
                    <>
                        {/* Back to Home */}
                        <div className="flex items-center gap-2">
                            <span className="bg-white text-gray-700 px-2 py-1 rounded-md text-sm shadow-md border font-medium">
                                Menu Utama
                            </span>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            size="icon"
                                            className="h-10 w-10 rounded-full shadow-lg bg-pink-500 hover:bg-pink-600 text-white"
                                            onClick={() => {
                                                onHome();
                                                setIsOpen(false);
                                            }}
                                        >
                                            <Home className="h-5 w-5" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent side="left">
                                        <p>Kembali ke Menu Utama</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>

                        {/* Back to Previous */}
                        <div className="flex items-center gap-2">
                            <span className="bg-white text-gray-700 px-2 py-1 rounded-md text-sm shadow-md border font-medium">
                                Kembali
                            </span>
                            <TooltipProvider>
                                <Tooltip>
                                    <TooltipTrigger asChild>
                                        <Button
                                            size="icon"
                                            className="h-10 w-10 rounded-full shadow-lg bg-orange-500 hover:bg-orange-600 text-white"
                                            onClick={() => {
                                                onBack();
                                                setIsOpen(false);
                                            }}
                                        >
                                            <ArrowLeft className="h-5 w-5" />
                                        </Button>
                                    </TooltipTrigger>
                                    <TooltipContent side="left">
                                        <p>Kembali ke Folder Sebelumnya</p>
                                    </TooltipContent>
                                </Tooltip>
                            </TooltipProvider>
                        </div>
                    </>
                )}

                {/* Create Folder */}
                <div className="flex items-center gap-2">
                    <span className="bg-white text-gray-700 px-2 py-1 rounded-md text-sm shadow-md border font-medium">
                        Buat Folder
                    </span>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    size="icon"
                                    className="h-10 w-10 rounded-full shadow-lg bg-green-500 hover:bg-green-600 text-white"
                                    onClick={() => {
                                        onCreateFolder();
                                        setIsOpen(false);
                                    }}
                                >
                                    <FolderPlus className="h-5 w-5" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent side="left">
                                <p>Buat Folder Baru</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>

                {/* Upload File */}
                <div className="flex items-center gap-2">
                    <span className="bg-white text-gray-700 px-2 py-1 rounded-md text-sm shadow-md border font-medium">
                        Upload File
                    </span>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild>
                                <Button
                                    size="icon"
                                    className="h-10 w-10 rounded-full shadow-lg bg-blue-500 hover:bg-blue-600 text-white"
                                    onClick={() => {
                                        onUploadFile();
                                        setIsOpen(false);
                                    }}
                                >
                                    <FileUp className="h-5 w-5" />
                                </Button>
                            </TooltipTrigger>
                            <TooltipContent side="left">
                                <p>Upload File</p>
                            </TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>

                {/* Upload Folder (Optional but good to have) - Keeping it commented or hidden unless requested, 
            but based on user Prompt "create directory new and upload file", I'll stick to those two to match the "two white buttons" description if possible. 
            However, user usually appreciates full parity. 
            I'll stick to the 2 requested to match the screenshot better (it showed 2 small buttons).
        */}

            </div>

            {/* Main Toggle Button */}
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            size="icon"
                            className={cn(
                                "h-14 w-14 rounded-full shadow-xl transition-transform duration-300",
                                isOpen ? "bg-red-500 hover:bg-red-600 rotate-180" : "bg-primary hover:bg-primary/90"
                            )}
                            onClick={toggleMenu}
                        >
                            {isOpen ? <X className="h-6 w-6" /> : <Plus className="h-8 w-8" />}
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">
                        <p>{isOpen ? 'Tutup Menu' : 'Menu Cepat'}</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default FloatingActionMenu;
